<template>
  <div>
    <c-card title="검진소견서 엑셀업로드" class="cardClassDetailForm">
      <template slot="card-button">
        <q-btn-group outline>
          <c-btn
            v-if="editable"
            label="LBLAPPLY"
            icon="save"
            @btnClicked="acceptData"
          />
        </q-btn-group>
      </template>
      <template slot="card-detail">
        <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
          <c-text
            :editable="editable"
            :disabled="true"
            label="병원"
            name="hospitalName"
            v-model="popupParam.hospitalName"
          >
          </c-text>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
          <c-text
            :editable="editable"
            :disabled="true"
            label="요청부서/이름/일자"
            name="request"
            v-model="request"
          >
          </c-text>
        </div>
      </template>
    </c-card>
    <c-check-up-opinion-excel-upload
      :editable="editable"
      :hospitalId="popupParam.hospitalId"
      :excelUploadInfo="excelUploadInfo"
      :isCustomDown="true"
      tabHeight="660px"
      gridHeight="630px"
      @noUpload="noUpload"
    >
    </c-check-up-opinion-excel-upload>
  </div>
</template>

<script>
export default {
  name: "checkup-result-opinion-excel-upload",
  props: {
    popupParam: {
      type: Object,
      default: function () {
        return {
          plantCd: "",
          hospitalId: null,
          hospitalName: "",
        };
      },
    },
  },
  data() {
    return {
      excelUploadInfo: {
        rowKeys: ["heaCheckupResultId"], // 데이터들의 키 속성값
        taskClassCd: "HEA_RESULT_OPINION", // 엑셀업로드 양식 구분 값
        sheetNum: 0,
        columns: [
          [
            {
              name: "deptName",
              field: "deptName",
              label: "공정(부서)",
              align: "center",
              style: "width:150px",
            },
            {
              name: "empNo",
              field: "empNo",
              label: "사번",
              align: "center",
              style: "width:100px",
              sortable: false,
            },
            {
              name: "userName",
              field: "userName",
              label: "성명",
              align: "center",
              style: "width:100px",
              sortable: false,
            },
            {
              name: "sexName",
              field: "sexName",
              label: "성별",
              align: "center",
              style: "width:80px",
              sortable: false,
            },
            {
              name: "birthDate",
              field: "birthDate",
              label: "생년월일",
              align: "center",
              style: "width:100px",
              sortable: false,
            },
            {
              name: "checkupType",
              field: "checkupType",
              label: "검진구분",
              align: "center",
              style: "width:100px",
              sortable: false,
            },
            {
              name: "checkupDate",
              field: "checkupDate",
              label: "검진일자",
              align: "center",
              style: "width:100px",
              sortable: false,
            },
            {
              name: "hazardName",
              field: "hazardName",
              label: "유해인자",
              align: "center",
              style: "width:200px",
              sortable: false,
            },
            {
              name: "healthType",
              field: "healthType",
              label: "건강구분",
              align: "center",
              style: "width:80px",
              sortable: false,
            },
            {
              name: "checkupOpinion",
              field: "checkupOpinion",
              label: "검진소견",
              align: "left",
              style: "width:200px",
              sortable: false,
            },
            {
              name: "opinionDetailResult",
              field: "opinionDetailResult",
              label: "소견 세부결과",
              align: "left",
              style: "width:500px",
              sortable: false,
            },
            {
              name: "afterManage",
              field: "afterManage",
              label: "사후관리소견",
              align: "left",
              style: "width:500px",
              sortable: false,
            },
            {
              name: "suitableFlag",
              field: "suitableFlag",
              label: "업무수행적합여부",
              align: "center",
              style: "width:80px",
              sortable: false,
            },
            // {
            //   name: 'suitableType',
            //   field: 'suitableType',
            //   label: '구분',
            //   align: 'center',
            //   style: 'width:80px',
            //   sortable: false,
            // },
            {
              name: "remark",
              field: "remark",
              label: "비고",
              align: "left",
              style: "width:1000px",
              sortable: false,
            },
          ],
        ],
        data: [],
      },
      templateData: "",
      editable: true,
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {},
  computed: {
    request() {
      return (
        this.$store.getters.user.deptName +
        " / " +
        this.$store.getters.user.userName +
        " / " +
        this.$comm.getToday()
      );
    },
  },
  methods: {
    init() {
      this.editable = this.$route.meta.editable;
    },
    acceptData() {
      if (this.excelUploadInfo.data) {
        let dataCntCheck = true;
        let errorDataCheck = false;
        if (
          !this.excelUploadInfo.data[0] ||
          this.excelUploadInfo.data[0].length === 0
        ) {
          dataCntCheck = false;
        }
        if (
          this.$_.findIndex(this.excelUploadInfo.data[0], (item) => {
            return item.error_message;
          }) > -1
        ) {
          errorDataCheck = true;
        }
        if (!dataCntCheck) {
          window.getApp.$emit("ALERT", {
            title: "LBLGUIDE", // 안내
            message:
              "업로드할 데이터가 없는 Sheet가 있습니다.\n데이터 확인 또는 엑셀을 업로드 하였는지 확인바랍니다.",
            type: "warning", // success / info / warning / error
          });
        } else {
          if (errorDataCheck) {
            window.getApp.$emit("CONFIRM", {
              title: "LBLCONFIRM",
              message:
                "에러가 있는 데이터가 존재합니다.\n에러 있는 데이터를 제외한 나머지 데이터를 적용하시겠습니까?",
              // TODO : 필요시 추가하세요.
              type: "info", // success / info / warning / error
              // 확인 callback 함수
              confirmCallback: () => {
                this.$emit("closePopup", this.excelUploadInfo.data[0]);
              },
              // 취소 callback 함수
              cancelCallback: () => {},
            });
          } else {
            this.$emit("closePopup", this.excelUploadInfo.data[0]);
          }
        }
      }
    },
    /* eslint-disable no-unused-vars */
    downTemplate() {
      let url = window.URL || window.webkitURL;
      let link = document.createElement("a");
      let blob = this.$comm.base64ToBlob(
        this.templateData,
        this.fileInfo.fileExt,
      );
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, this.fileInfo.oriFileNm);
      } else {
        let link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = this.fileInfo.oriFileNm;
        link.click();
      }
    },
    noUpload(isUpload) {
      this.$emit("noUpload", isUpload);
    },
  },
};
</script>
